import { Stack, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import React, { useEffect } from "react";
import Selection from "components/Input/Selection/Selection";
import Datepicker from "components/Input/Datepicker/Datepicker";
import ShareholderFields from "./ShareholderFields";
import { CustomComponentCommonProps, rules } from "../utils";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import dayjs from "dayjs";
const CompanyInfoSession = ({
  control,
  isEdit,
  mccDropdownOptions,
  isLoading,
  clearErrors,
}) => {
  const { t } = useTranslation();
  const PAGE_LOCALE_KEY = "page.merchants.";
  const FORM_LABEL_KEY =
    PAGE_LOCALE_KEY + "merchantDetail.info.companyInfo.fields";

  const formValue = useWatch({ control });

  useEffect(() => {
    if (clearErrors && formValue?.ownershipType !== "Limited Company") {
      clearErrors("ciNumber");
      clearErrors("businessEstablishedDate");
    }
  }, [clearErrors, formValue?.ownershipType]);

  // useEffect(() => {
  //   console.log(
  //     "formValue.businessEstablishedDate",
  //     formValue.businessEstablishedDate,
  //   );
  //   console.log("today", dayjs());
  //   console.log(dayjs(formValue.businessEstablishedDate).isAfter(dayjs()));
  // }, [formValue]);

  return (
    <Stack direction={"column"} rowGap={2} width={"80%"}>
      <Typography variant="h3">
        {t(`${PAGE_LOCALE_KEY}merchantDetail.info.companyInfo.title`)}
      </Typography>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="ownerName"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            maxLength: 50,
            validationTags: [
              "noLeadingWhitespace",
              "noQuotesOrBackticks",
              "noChineseCharacters",
              "noFullwidthCharacters",
              "noSpecialSpaces",
            ],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownerName`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="ownerNameSecondaryLang"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 255,
            validationTags: ["noLeadingWhitespace", "noQuotesOrBackticks"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownerNameSecondaryLang`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            maxLength: 22,
            validationTags: [
              "noLeadingWhitespace",
              "noQuotesOrBackticks",
              "noChineseCharacters",
              "noFullwidthCharacters",
              "noSpecialSpaces",
            ],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.name`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <Controller
          name="nameSecondaryLang"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 255,
            validationTags: ["noLeadingWhitespace", "noQuotesOrBackticks"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.nameSecondaryLang`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading,
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="ownerCountry"
          control={control}
          defaultValue=""
          rules={rules({ required: true })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Selection
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={[
                {
                  key: "hk",
                  title: "Hong Kong",
                  value: "HK",
                },
                {
                  key: "sg",
                  title: "Singapore",
                  value: "SG",
                },
              ]}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownerCountry`),
                value,
                "Selection",
                true,
                isEdit,
                isLoading,
              )}
              sxParams={{
                selectionError: !!error,
              }}
            />
          )}
        />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="ownerAddress1"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            maxLength: 255,
            validationTags: ["onlyAlphabetNumAndSpaces"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownerAddress1`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="ownerAddress2"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 255,
            validationTags: [
              "noLeadingWhitespace",
              "onlyAlphabetNumChineseAndSpaces",
            ],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownerAddress2`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading,
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="ownershipType"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Selection
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={[
                {
                  key: "Limited Company",
                  title: "Limited Company",
                  value: "Limited Company",
                },
                {
                  key: "Sole-proprietorship",
                  title: "Sole-proprietorship",
                  value: "Sole-proprietorship",
                },
                {
                  key: "Partnership",
                  title: "Partnership",
                  value: "Partnership",
                },
                {
                  key: "Others",
                  title: "Others",
                  value: "Others",
                },
              ]}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ownershipType`),
                value,
                "Selection",
                true,
                isEdit,
                isLoading,
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="ciNumber"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 255,
            validationTags: [
              "noQuotesOrBackticks",
              "onlyInteger",
              "noLeadingWhitespace",
            ],
          })} 
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.ciNumber`),
                value,
                "OutlinedText",
                formValue.ownershipType === "Limited Company",
                isEdit,
                isLoading,
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="businessEstablishedDate"
          control={control}
          defaultValue=""
          rules={rules({
            validationTags: ["validDate", "onlyBeforeToday"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Datepicker
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              errorMessage={error?.message || ""}
              type="start"
              limitValue={dayjs()}
              onchangeFn={onChange}
              sxParams={{
                datepickerError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.businessEstablishedDate`),
                value,
                "Datepicker",
                formValue.ownershipType === "Limited Company",
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <ShareholderFields control={control} isEdit={isEdit} isLoading={isLoading} />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="merchantCategoryCode"
          control={control}
          defaultValue=""
          rules={rules({ required: true })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Selection
              errorMessage={"page.finance.refund.list.id.error.message"}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={mccDropdownOptions ?? []}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.merchantCategoryCode`),
                value,
                "Selection",
                true,
                isEdit,
                isLoading,
              )}
              sxParams={{
                selectionError: !!error,
              }}
            />
          )}
        />
        <Controller
          name="businessNature"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange }, fieldState: {} }) => (
            <Selection
              selectionValue={value}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={[
                {
                  key: "Restaurant",
                  title: "Restaurant",
                  value: "Restaurant",
                },
                {
                  key: "Retail",
                  title: "Retail",
                  value: "Retail",
                },
                {
                  key: "Services",
                  title: "Services",
                  value: "Services",
                },
              ]}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.businessNature`),
                value,
                "Selection",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="contactPerson"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            maxLength: 255,
            validationTags: [
              "noLeadingWhitespace",
              "onlyAlphabetAndSpaces",
              "noQuotesOrBackticks",
              "noFullwidthCharacters",
              "noSpecialSpaces",
            ],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""} // Show actual error message
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "400px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.contactPerson`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <Controller
          name="phone"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            validationTags: ["validPhoneNumber"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""} // Show actual error message
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "400px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.phone`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            validationTags: ["validEmail"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""} // Show actual error message
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "400px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.email`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
      </Stack>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="businessPlan"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Selection
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={[
                {
                  key: "sme",
                  title: "SME",
                  value: "sme",
                },
                {
                  key: "normal",
                  title: "Standard",
                  value: "normal",
                },
              ]}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.businessPlan`),
                value,
                "Selection",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <Controller
          name="isoAgentId"
          control={control}
          defaultValue=""
          rules={rules({
            required: true,
            validationTags: ["onlyInteger"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""} // Show actual error message
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.isoAgentId`),
                value,
                "OutlinedText",
                true,
                isEdit,
                isLoading,
              )}
              id={`isoAgentId`}
            />
          )}
        />
      </Stack>
    </Stack>
  );
};
export default React.memo(CompanyInfoSession);
